import React, {Suspense, useCallback, useContext, useState} from "react";
import MainMenu from "./MainMenu";
import SecondMenu from "./SecondMenu";
import {GlobalContext} from "@tools/globalContext";
import usePlugins from "./usePlugins";
import LoadingComponent from "@components/loadingComponent/LoadingComponent";

const Navbar: React.FC = () => {
    const [Plugin, setPlugin] = useState<any>(null)
    const { pagesConfig, pagesDecorator} = useContext(GlobalContext);
    const plugins = usePlugins({pagesConfig});

    const onMenuClick = useCallback((pluginName: string) => {
        if (plugins.get(pluginName))
            setPlugin(plugins.get(pluginName))
    }, [plugins])

    const onPluginClose = useCallback(() => {
        setPlugin(null)
    }, [])

   return <>
       <div style={{position: "absolute", top:0, left:0, width: 0, height: 0}}>
            {Plugin && <Suspense fallback={<LoadingComponent />}>
                <Plugin onClose={onPluginClose}/>
            </Suspense>}
       </div>
       <MainMenu onClick={onMenuClick} config={pagesConfig} decorator={pagesDecorator} />
       <SecondMenu onClick={onMenuClick} config={pagesConfig}  decorator={pagesDecorator} />
   </>
}

export default Navbar
